"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Toggle } from "@/components/ui/toggle";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail, Facebook, Twitter, Linkedin, Globe, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        {[{
        label: "Home",
        href: "/HomePage"
      }, {
        label: "About",
        href: "/AboutPage"
      }, {
        label: "Services",
        href: "/ServicesPage"
      }, {
        label: "Contact",
        href: "/ContactPage"
      }].map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="text-muted-foreground hover:text-primary transition-colors duration-300 text-sm font-medium">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-300 text-sm font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function AviationLogisticsFooter() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Terms of Service",
    href: "#"
  }, {
    label: "Cookie Policy",
    href: "#"
  }];
  return <footer id="aviation-logistics-footer" className="dark bg-background text-foreground pt-20 pb-8 px-6 md:px-12 border-t border-border/40">
      <div className="max-w-7xl mx-auto">
        
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591502/img/hlc_gold_logo.png" alt="HLC Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6 max-w-xs">
              Your reliable partner for aviation logistics and ground handling. Specialized in air cargo handling and logistics services, supporting airlines, crews, and passengers.
            </p>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20">
              <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
              <span className="text-xs font-semibold text-primary tracking-wider uppercase">
                Safety • Speed • Efficiency
              </span>
            </div>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-6 tracking-wide">Quick Links</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-6 tracking-wide">N'djili Hub Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>N’djili International Airport, DR Congo</span>
              </li>
              <li>
                <Link to="tel:+243810641198" className="flex items-center gap-3 text-sm text-muted-foreground hover:text-primary transition-colors group"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone size-5 text-primary shrink-0 group-hover:scale-110 transition-transform" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:81asnh" data-ast-start="4336" data-ast-end="4429"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg><span data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:h38q7q" data-ast-start="4448" data-ast-end="4477">+243 810 641 198<br />+243 998 332 998<br />+243 840 161 875</span></Link>
              </li>
              <li>
                <Link to="mailto:ddchambangi@gmail.com" className="flex items-center gap-3 text-sm text-muted-foreground hover:text-primary transition-colors group">
                  <Mail className="size-5 text-primary shrink-0 group-hover:scale-110 transition-transform" />
                  <span>ddchambangi@gmail.com</span>
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-6 tracking-wide">Preferences & Connect</h3>
            
            {}
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-3">
                <Globe className="size-4 text-muted-foreground" />
                <span className="text-sm text-muted-foreground font-medium">Select Language</span>
              </div>
              <div className="inline-flex bg-secondary/50 p-1 rounded-lg border border-border/50">
                <Toggle pressed={true} className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground px-6 h-10 rounded-md font-semibold transition-all">
                  EN
                </Toggle>
                <Toggle pressed={false} className="data-[state=on]:bg-primary data-[state=on]:text-primary-foreground px-6 h-10 rounded-md font-semibold transition-all hover:bg-accent/50">
                  FR
                </Toggle>
              </div>
            </div>

            {}
            <div className="flex items-center gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} aria-label={social.label} className="flex items-center justify-center size-10 rounded-full border border-primary/30 bg-primary/5 text-primary hover:bg-primary hover:text-primary-foreground hover:scale-110 transition-all duration-300 shadow-[0_0_15px_rgba(255,191,0,0.1)] hover:shadow-[0_0_20px_rgba(255,191,0,0.3)]">
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>

        </div>

        {}
        <Separator className="bg-border/40 mb-8" />
        
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>© {currentYear} Handling and Logistic Company (HLC). All rights reserved.</p>
          
          <div className="flex items-center flex-wrap justify-center">
            {legalLinks.map((link, i) => <React.Fragment key={i}>
                <Link data-index={i} to={link.href} className="hover:text-primary transition-colors">
                  {link.label}
                </Link>
                {i < legalLinks.length - 1 && <span className="text-primary/50 mx-3 font-light">|</span>}
              </React.Fragment>)}
          </div>
        </div>

      </div>
    </footer>;
}